import { gql } from '@apollo/client';

import { BusinessQuestionsFragment } from './BusinessQuestions.graphql';

export const CompanyFragment = gql`
  fragment Company on Company {
    id
    legalName
    shortName
    companyCreationType
    organizationId
    isPiiRedacted
    ascLockedUntilMonthYear
    lastCompletedAscSyncPeriodEnd
    syncConfigurationAsc {
      id
      clusteringMethod
    }
    businessQuestions {
      ...BusinessQuestions
    }
  }
  ${BusinessQuestionsFragment}
`;
